import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-portfolio',
  templateUrl: './main-portfolio.component.html',
  styleUrls: ['./main-portfolio.component.css']
})
export class MainPortfolioComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
